import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTypeStringQuote = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.85201 14.2245C8.93065 14.0544 8.74182 13.8824 8.56763 13.9515C8.08258 14.1441 7.55365 14.25 7 14.25C4.65279 14.25 2.75 12.3472 2.75 10C2.75 7.65279 4.65279 5.75 7 5.75C9.34721 5.75 11.25 7.65279 11.25 10C11.25 10.0027 11.25 10.0055 11.25 10.0082C11.2479 12.8012 10.2048 16.6763 6.88235 18.6452C6.526 18.8564 6.06594 18.7387 5.85478 18.3824C5.64361 18.026 5.7613 17.5659 6.11764 17.3548C7.39081 16.6003 8.275 15.4729 8.85201 14.2245ZM4.25 10C4.25 8.48122 5.48122 7.25 7 7.25C8.51798 7.25 9.7487 8.47992 9.75 9.9976L9.75 10L9.75 10.0044C9.7476 11.5212 8.5173 12.75 7 12.75C5.48122 12.75 4.25 11.5188 4.25 10Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17 5.75C19.3472 5.75 21.25 7.65279 21.25 10L21.25 10.0069C21.2483 12.8 20.2054 16.676 16.8823 18.6452C16.526 18.8564 16.0659 18.7387 15.8548 18.3824C15.6436 18.026 15.7613 17.5659 16.1176 17.3548C17.3908 16.6003 18.275 15.4729 18.852 14.2245C18.9306 14.0544 18.7418 13.8824 18.5676 13.9515C18.0826 14.1441 17.5536 14.25 17 14.25C14.6528 14.25 12.75 12.3472 12.75 10C12.75 7.65279 14.6528 5.75 17 5.75ZM14.25 10C14.25 8.48122 15.4812 7.25 17 7.25C18.5181 7.25 19.7488 8.48006 19.75 9.99786V10L19.75 10.0054C19.7471 11.5217 18.517 12.75 17 12.75C15.4812 12.75 14.25 11.5188 14.25 10Z",
		fill: "currentColor"
	})]
});
export { SvgIconTypeStringQuote as ReactComponent };
